import React from 'react';
import cx from 'classnames';
import picture from '../../assets/img/moi.webp';
import style from './Picture.module.css';

/**
 * ## Display a picture of me for the phone and low width screens
 *
 * @returns React.ReactNode
 */
function PhonePicture() {
  return (
    <div className="col-12 d-block d-sm-none">
      <img
        src={picture}
        className={cx(style.mainImgMobile, 'img-fluid')}
        width="294"
        height="274"
        alt="me"
      />
    </div>
  );
}

export default PhonePicture;
